<template>
  <div class="dialog_wrap" page-data="index:index" style="display: block;">
    <div class="dialog_layout">
      <div class="dialog_container">
        <img src="http://site.cc/static/txys-001/image/loading.gif" class="loading_img" style="display: none;">
        <div class="form_warp" style="display: block;">
          <div class="dialog_title">
            <span class="title"></span>
            <i class="dialog_close iconfont icon-chuyidong" @click="onClickCloseBtn"></i>
          </div>
          <div class="dialog_content">
            <form class="my_form form-horizontal" id="forms">
              <div class="form_content">
                <div class="form-tip-job"></div>
                <input type="hidden" name="id" id="id" value="4">
                <div class="form_item_wrap" data-comb-dom="" style="width:33%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2522')}}</span><span
                    class="required_icon">*</span></h3><input disabled autocomplete="off" maxlength="20" id="name"
                                                              name="name"
                                                              :placeholder="$t('view_test_2503')"
                                                              class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div class="form_item_wrap" data-comb-dom="" style="width:33%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('base_options_config_1784')}}</span><span
                    class="required_icon">*</span></h3>
                    <div class="item_type_phone content">
                      <div class="phone_number_area">
                        <div class="phone_number_wrap">
                          <input disabled autocomplete="off" maxlength="11" id="phone" name="phone"
                                 :placeholder="$t('view_login_index_48')"
                                 class="input_style jz_focus jz_theme_focus_border_color">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form_item_wrap" data-comb-dom="" style="width:34%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2523')}}</span><span
                    class="required_icon">*</span></h3><input disabled autocomplete="off" maxlength="50" id="email"
                                                              name="email"
                                                              :placeholder="$t('widgets_basic_job_components_table1_2524')"
                                                              class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div class="form_item_wrap form_item_wrap-resume" data-comb-dom="" style="width:100%">
                  <div class="form_item"><h3 class="title"><span class="title_text">{{$t('widgets_basic_job_components_table1_2525')}}</span></h3>
                    <div class="item_type_textarea content form-content-resume">
                      <table class="basic-job-resume resume-table-u711703 table-3" style="display: table;">
                        <tbody>
                        <tr>
                          <td>
                            <div class="cell">
                              <span class="label label-name"></span>
                              <input type="text" data-field="name" class="txt input-name">
                            </div>
                          </td>
                          <td>
                            <div class="cel">
                              <span class="label label-sex"></span>
                              <input data-field="sex" class="txt input-sex">
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <span class="label label-native_place"></span>
                              <input type="text" data-field="native_place" class="txt input-native_place">
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <span class="label label-birthday"></span>
                              <input type="text" data-field="birthday" class="txt input-birthday">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="cell">
                              <span class="label label-best_education"></span>
                              <input type="text" data-field="best_education" class="txt input-best_education">
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <span class="label label-major"></span>
                              <input type="text" data-field="major" class="txt input-major">
                            </div>
                          </td>
                          <td colspan="2">
                            <div class="cell">
                              <span class="label label-graduated_school"></span>
                              <input type="text" data-field="graduated_school" class="txt input-graduated_school">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <div class="cell">
                              <span class="label label-register_address"></span>
                              <input type="text" data-field="register_address" class="txt input-register_address">
                            </div>
                          </td>
                          <td colspan="2">
                            <div class="cell">
                              <span class="label label-id_card"></span>
                              <input type="text" data-field="id_card" class="txt input-id_card">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="cell">
                              <span class="label label-mailing_address"></span>
                              <input type="text" data-field="mailing_address" class="txt input-mailing_address">
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <span class="label label-postcode"></span>
                              <input type="text" data-field="postcode" class="txt input-postcode">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <div class="cell">
                              <span class="label label-phone"></span>
                              <input type="text" data-field="phone" class="txt input-phone">
                            </div>
                          </td>
                          <td colspan="2">
                            <div class="cell">
                              <span class="label label-email"></span>
                              <input type="text" data-field="email" class="txt input-email">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-english_level"></span>
                              <input type="text" data-field="english_level" class="txt input-english_level">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-computer_level"></span>
                              <input type="text" data-field="computer_level" class="txt input-computer_level">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-other_skill"></span>
                              <input type="text" data-field="other_skill" class="txt input-other_skill">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-education_back"></span>
                              <input type="text" data-field="education_back" class="txt input-education_back">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-winning"></span>
                              <input type="text" data-field="winning" class="txt input-winning">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-job_experience"></span>
                              <input type="text" data-field="job_experience" class="txt input-job_experience">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-self_evaluate"></span>
                              <input type="text" data-field="self_evaluate" class="txt input-self_evaluate">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <div class="cell">
                              <span class="label label-remark"></span>
                              <input type="text" data-field="remark" class="txt input-remark"/>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-for="(value, key) in mobileLabelMap" :key="key" class="form_item_wrap form_item_wrap_mb"
                     style="width:100%">
                  <div class="form_item">
                    <h3 class="title"><span class="title_text">{{ value }}</span></h3>
                    <input
                      autocomplete="off" disabled maxlength="20"
                      ::placeholder="$t('widgets_basic_job_components_table1_2526', [value])"
                      class="input_style jz_focus jz_theme_focus_border_color">
                  </div>
                </div>
                <div style="width:69%" class="form_item_wrap fixed_item formitem_validateCode" data-comb-dom="">
                  <div class="form_item">
                    <div class="item_type_validateCode content">
                      <input disabled autocomplete="off" :placeholder="$t('view_login_index_47')" maxlength="4" id="verify" name="verify"
                             class="validateCode_input input_style jz_focus jz_theme_focus_border_color">
                      <img alt=" " src="/static/image/verify.png" class="validateCode_img">
                    </div>
                  </div>
                </div>
                <div style="width:11%" class="form_item_wrap fixed_item formitem_submit" data-comb-dom="">
                  <div class="form_item" style="text-align: center">
                    <button class="form_submit content jz_theme_bg_color" type="button" @click="onClickSubmitBtn">{{$t('widgets_basic_job_components_table1_2527')}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_job_table3",
  data() {
    return {
      styleType: 3,
      widgetId: '',
      labelMap: {},
      mobileExcludeKeys: ['name', 'phone', 'email']
    }
  },
  computed: {
    mobileLabelMap() {
      return Object.keys(this.labelMap).filter(key => !this.mobileExcludeKeys.includes(key) && this.labelMap[key]).map(key => this.labelMap[key])
    }
  },
  methods: {
    onClickSubmitBtn() {
      this.$message({showClose: true, message: i18n.t('components_set_link_components_submit_form_index_2470')});
    },
    onClickCloseBtn() {
      this.close()
    },
    close() {
      $(this.$el).remove()
    }
  }
}
</script>

<style scoped lang="scss">
@import "./src/css/components/basic_job_table";
</style>



// WEBPACK FOOTER //
// src/widgets/basic_job/components/table3.vue